import React from 'react'
import PropTypes from 'prop-types'

import { DriverTableHead } from '../components/Table/data'
import BodyContainer from '../components/bodyContainer'

const DriverList = ({
  fetchData,
  isLoadingDriverList,
  drivers,
  driverCount,
  errorMessage,
  removeError,
  isErrorFetch,
  pageLimitChanged,
  pageChanged,
  success,
  isSuccessRefresh,
  resetSuccessAction,
  searchData,
  onCloseReset,
  errorMessageConfig,
  removeErrorConfig,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={false}
      //TableMode
      actionButton={true}
      tableHead={DriverTableHead}
      //Commonfields
      globalID={'Driver'}
      searchPlaceholder={'Rechercher par chauffeur'}
      title={'Chauffeur'}
      fetchData={fetchData}
      loadingData={isLoadingDriverList}
      dataList={drivers}
      countData={driverCount}
      errorMessage={errorMessage || errorMessageConfig}
      removeError={removeError}
      removeErrorConfig={removeErrorConfig}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchData}
      onCloseReset={onCloseReset}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isDriver={true}
    />
  )
}
DriverList.propTypes = {
  drivers: PropTypes.array,
  fetchData: PropTypes.func,
  isLoadingDriverList: PropTypes.bool,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  searchKeys: PropTypes.func,
  onCloseReset: PropTypes.func,
  searchData: PropTypes.func,
  success: PropTypes.bool,
  driverCount: PropTypes.number,
  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
  errorMessageConfig: PropTypes.string,
  removeErrorConfig: PropTypes.func,
}
export default DriverList
